<div class="content">
    <div class="image" showleft>
        <img ngSrc="/images/home/veyora-detail.webp" fill alt="{{appname}} activewear fabric and movement detail">
    </div>
    <div class="texts">
        <p class="eyebrow" showright [showDelay]="50">Our fit philosophy</p>
        <h2 showright [showDelay]="120">Activewear that feels calm, capable, and refined.</h2>
        <p showright [showDelay]="190">Every piece is chosen for how it moves through real life: smooth waistbands,
            breathable stretch, clean lines, and colors that work far beyond the studio.</p>
        <div class="stats" showright [showDelay]="260">
            <div>
                <strong>4-way</strong>
                <span>responsive stretch</span>
            </div>
            <div>
                <strong>All day</strong>
                <span>studio-to-street polish</span>
            </div>
        </div>
        <a matButton="outlined" routerLink="/about-us" aria-label="{{appname}} story" showright
            [showDelay]="330">Meet Veyora Fit</a>
    </div>
</div>
